import React from 'react';
import ResourceSidebar from '../ResourceSidebar/ResourceSidebar';
import './ResourceLayout.css';

const ResourceLayout = ({ currentView, onViewChange, counts, children, title, subtitle, dataInfo }) => {
  return (
    <div className="resource-layout">
      <ResourceSidebar 
        currentView={currentView}
        onViewChange={onViewChange}
        counts={counts}
      />
      <div className="main-content">
        <header className="content-header">
          <h1>{title || 'Project Resource Dashboard'}</h1>
          <p>{subtitle || 'Billable Resource Count Analysis & Deviation Tracking'}</p>
          {dataInfo && (
            <div className="data-info">
              {dataInfo.map((info, index) => (
                <span key={index} className={info.className || ''}>
                  {info.text}
                </span>
              ))}
            </div>
          )}
        </header>
        <div className="content-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ResourceLayout;